import { render, staticRenderFns } from "./_ActionsColumns.vue?vue&type=template&id=121b4131&"
import script from "./_ActionsColumns.vue?vue&type=script&lang=ts&"
export * from "./_ActionsColumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports